import { render, staticRenderFns } from "./IUJP.vue?vue&type=template&id=da98a914&"
import script from "./IUJP.vue?vue&type=script&lang=js&"
export * from "./IUJP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports